export default __webpack_public_path__ + "static/media/exclamationcircleblue.cc6d5acc.svg";